import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Job } from '../model/job';
import { HttpClient } from '@angular/common/http';
import { JobSerializer } from '../model/serializer/job-serializer';

import { environment } from '@environments/environment';

@Injectable({ providedIn: 'root' })
export class JobService extends ApiService<Job> {

  constructor(httpClient: HttpClient) {
    super(httpClient,
      environment.apiUrl,
      'job',
      new JobSerializer());
  }
}
